export default __webpack_public_path__ + "static/SleighLogo-White-13e11a0787622d0d0727cb88f2ed6310.png";